import React from 'react'
import slider2 from '../../../../../assets/img/diet_care.webp'
import { Link } from 'react-router-dom'

function DietCaresec1() {
  return (
    <section className='hmslder-sec abt-sec'>
        <div className='breadcrumbs'>
            <div className='container'>
             <ul>
               <li><Link to='/'>Home</Link></li>
               <li><Link to='/product'>Product</Link></li> 
               <li>Diet Care</li>   
             </ul> 
             </div> 
        </div>
        <div className='container'>
           <div className='hmslder-txt'>
              <h2>Diet <span>Care</span></h2>
              <p>Diet Care is a revolutionary diet and nutrition application designed to fit your nutriment and fitness standards in every way possible. With personalized solutions to cater to the health goals you have set for yourself, Diet Care offers you the best with a whole lot of care.</p>
              <p>We’re here to help you meet your health goals! Our team of experts are ready to help you achieve results with more than just personalized and specialty membership plans.</p>
              <p>Diet care boasts a range of inhouse and phone consultation options that are sure to take you down the right diet plan.</p>
            </div> 
           <div className='hmslder-img'>
              <img src={slider2} alt='Diet Care' width={1200} height={800} loading="lazy" />
            </div>  
        </div>
    </section>
  )
}

export default DietCaresec1
